import { useCallback } from 'react'

import { useAiChat } from '@factorialco/f0-react'

import { buildInsightsPrompt } from 'modules/posts/lib/buildInsightsPrompt'

type PostInsightsData = {
  postId: string
  title?: string | null
  communityTitle?: string | null
  hasRequiredActions: boolean
}

export const useOpenInsightsChat = () => {
  const { enabled: aiEnabled, sendMessage, setOpen: setAiChatOpen } = useAiChat()

  const openInsightsChat = useCallback(
    (data: PostInsightsData) => {
      if (!aiEnabled) return

      const prompt = buildInsightsPrompt({
        postId: data.postId,
        title: data.title,
        communityTitle: data.communityTitle,
        hasRequiredActions: data.hasRequiredActions,
      })

      setAiChatOpen(true)
      sendMessage(prompt)
    },
    [aiEnabled, sendMessage, setAiChatOpen]
  )

  return { aiEnabled, openInsightsChat }
}
